module.exports = __webpack_public_path__ + "static/media/residential-townhouses.98312cc1.svg";